import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * After Google OAuth, the API sets httpOnly cookies and redirects here.
 * We refresh AuthContext then send the user into the app (ProtectedRoute handles onboarding).
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const ok = await refreshMe();
        if (cancelled) return;
        if (ok) {
          navigate("/scribe", { replace: true });
        } else {
          navigate("/signin?oauth=session", { replace: true });
        }
      } catch (error) {
        console.error("Session validation failed", error);
        if (!cancelled) navigate("/signin?oauth=error", { replace: true });
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [navigate, refreshMe]);

   return (
    <div className="flex items-center justify-center min-h-screen">
      <div>Authenticating...</div>
    </div>
  );
};

export default AuthCallback;
